module.exports = __webpack_public_path__ + "img/docker.2103c445.png";